/**
 * anything that relates to DOM
 */
export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    isConnected: true, // atualizado pelo Capacitor Network plugin (confiável no Android)
    // true enquanto o relogin biométrico silencioso (recuperação de sessão no 401)
    // está em andamento — o layout mostra um overlay amigável em vez da tela branca.
    reloginPending: false,
    // 'wifi' | 'cellular' | 'none' | 'unknown' — alimentado pelo listener em main.js.
    // 'unknown' enquanto o boot não respondeu (default seguro: gates baseados em
    // cellular não disparam antes da primeira leitura).
    connectionType: 'unknown',
    // True enquanto uma aula em vídeo reproduz por STREAMING (localSrc nulo —
    // aula baixada tocando não disputa banda e não liga isto). Mantido pelo
    // Player.vue (started/ended/destroy); lido pela fila de downloads no
    // instante do enqueue pra reduzir a concorrência do batch (prioridade de
    // reprodução). Volátil de propósito: playback não sobrevive a reload.
    streamingPlaybackActive: false,
    /**
     * breakpoint constants
     */
    widthExtraSmall: 320,
    widthSmall: 640,
    widthTablet: 1024,
    widthDesktop: 1300
  },

  mutations: {
    SET_WINDOW_WIDTH (state, value) {
      state.windowWidth = value
    },
    SET_CONNECTED (state, value) {
      state.isConnected = value;
    },
    SET_CONNECTION_TYPE (state, value) {
      state.connectionType = value;
    },
    SET_RELOGIN_PENDING (state, value) {
      state.reloginPending = value;
    },
    SET_STREAMING_PLAYBACK (state, value) {
      state.streamingPlaybackActive = Boolean(value);
    }
  },

  getters: {
    isExtraSmall: (state) => state.windowWidth <= state.widthExtraSmall,
    isSmall: (state) => state.windowWidth <= state.widthSmall,
    isTablet: (state) => state.windowWidth <= state.widthTablet,
    isDesktop: (state) => state.windowWidth > state.widthDesktop,
    isConnected: (state) => state.isConnected,
    connectionType: (state) => state.connectionType,
    streamingPlaybackActive: (state) => state.streamingPlaybackActive
  }
}
